// Generiert mit "pnpm gen:laufwege" aus docs/laufwege.yaml (Stand 2026-09-19).
// Nicht von Hand ändern: die YAML ist die Quelle, diese Datei die Ableitung.

export const CATEGORIES = [
  { key: "obst_gemuese", label: "Obst und Gemüse" },
  { key: "backwaren", label: "Backwaren" },
  { key: "fleisch_fisch", label: "Fleisch und Fisch" },
  { key: "theke", label: "Bedienungstheke" },
  { key: "molkerei", label: "Molkerei und Kühlung" },
  { key: "wurst_kaese", label: "Wurst und Käse" },
  { key: "convenience", label: "Fertiggerichte und To-go" },
  { key: "trockensortiment", label: "Trockensortiment und Konserven" },
  { key: "suesswaren", label: "Süßwaren und Snacks" },
  { key: "tiefkuehl", label: "Tiefkühl" },
  { key: "getraenke", label: "Getränke" },
  { key: "drogerie", label: "Drogerie und Körperpflege" },
  { key: "haushalt", label: "Haushalt und Reinigung" },
  { key: "baby", label: "Baby und Kind" },
  { key: "tier", label: "Tierbedarf" },
  { key: "aktion", label: "Aktionsware" },
  { key: "kasse", label: "Kasse" },
  { key: "garten", label: "Garten" },
  { key: "bauen_holz", label: "Bauen und Holz" },
  { key: "werkzeug", label: "Werkzeug" },
  { key: "eisenwaren", label: "Eisenwaren (Schrauben, Dübel)" },
  { key: "elektro", label: "Elektro" },
  { key: "sanitaer", label: "Sanitär" },
  { key: "farben", label: "Farben und Lacke" },
  { key: "deko", label: "Deko und Wohnen" },
  { key: "asia_frische", label: "Frische und Kräuter" },
  { key: "asia_tofu", label: "Tofu und Kühlung" },
  { key: "asia_nudeln_reis", label: "Nudeln und Reis" },
  { key: "asia_saucen", label: "Saucen und Gewürze" },
  { key: "beauty", label: "Beauty und Make-up" },
  { key: "haar", label: "Haarpflege" },
  { key: "gesundheit", label: "Gesundheit" },
  { key: "ernaehrung", label: "Ernährung und Lebensmittel" },
] as const;

export type CategoryKey = (typeof CATEGORIES)[number]["key"];

export const CATEGORY_LABELS: Record<CategoryKey, string> = {
  obst_gemuese: "Obst und Gemüse",
  backwaren: "Backwaren",
  fleisch_fisch: "Fleisch und Fisch",
  theke: "Bedienungstheke",
  molkerei: "Molkerei und Kühlung",
  wurst_kaese: "Wurst und Käse",
  convenience: "Fertiggerichte und To-go",
  trockensortiment: "Trockensortiment und Konserven",
  suesswaren: "Süßwaren und Snacks",
  tiefkuehl: "Tiefkühl",
  getraenke: "Getränke",
  drogerie: "Drogerie und Körperpflege",
  haushalt: "Haushalt und Reinigung",
  baby: "Baby und Kind",
  tier: "Tierbedarf",
  aktion: "Aktionsware",
  kasse: "Kasse",
  garten: "Garten",
  bauen_holz: "Bauen und Holz",
  werkzeug: "Werkzeug",
  eisenwaren: "Eisenwaren (Schrauben, Dübel)",
  elektro: "Elektro",
  sanitaer: "Sanitär",
  farben: "Farben und Lacke",
  deko: "Deko und Wohnen",
  asia_frische: "Frische und Kräuter",
  asia_tofu: "Tofu und Kühlung",
  asia_nudeln_reis: "Nudeln und Reis",
  asia_saucen: "Saucen und Gewürze",
  beauty: "Beauty und Make-up",
  haar: "Haarpflege",
  gesundheit: "Gesundheit",
  ernaehrung: "Ernährung und Lebensmittel",
};

/** Farbton je Warengruppe, als Schlüssel in die Lebensmittelpalette. */
export const CATEGORY_COLORS: Record<CategoryKey, string> = {
  obst_gemuese: "basil",
  backwaren: "golden",
  fleisch_fisch: "tomato",
  theke: "roast",
  molkerei: "sea",
  wurst_kaese: "cream",
  convenience: "carrot",
  trockensortiment: "mushroom",
  suesswaren: "berry",
  tiefkuehl: "mint",
  getraenke: "lime",
  drogerie: "plum",
  haushalt: "fennel",
  baby: "lemon",
  tier: "roast",
  aktion: "tomato",
  kasse: "mushroom",
  garten: "basil",
  bauen_holz: "roast",
  werkzeug: "sea",
  eisenwaren: "mushroom",
  elektro: "golden",
  sanitaer: "mint",
  farben: "berry",
  deko: "plum",
  asia_frische: "basil",
  asia_tofu: "cream",
  asia_nudeln_reis: "golden",
  asia_saucen: "roast",
  beauty: "berry",
  haar: "plum",
  gesundheit: "mint",
  ernaehrung: "lime",
};

export type Confidence = "hoch" | "mittel" | "niedrig";

/** Konfidenz der Kette steuert die Lernrate der Gang-Sortierung. */
export const LEARNING_RATE: Record<Confidence, number> = {
  hoch: 0.2,
  mittel: 0.3,
  niedrig: 0.5,
};

export interface ChainProfile {
  readonly key: string;
  readonly name: string;
  readonly type: string;
  readonly confidence: Confidence;
  readonly note: string;
  readonly categoryOrder: readonly CategoryKey[];
  readonly expressRoute?: readonly CategoryKey[];
  readonly landmarks?: readonly string[];
}

export const CHAIN_PROFILES = [
  {
    key: "aldi_nord",
    name: "ALDI Nord",
    type: "discounter",
    confidence: "hoch",
    note: "Frischeinsel direkt hinter dem Eingang, äußerer Gang als Führungsachse, Food und Nonfood getrennt. Ältere Filialen ohne Store Layout 2.0 können abweichen.",
    categoryOrder: ["obst_gemuese", "convenience", "backwaren", "molkerei", "wurst_kaese", "fleisch_fisch", "trockensortiment", "suesswaren", "tiefkuehl", "getraenke", "aktion", "haushalt", "drogerie", "kasse"],
  },
  {
    key: "aldi_sued",
    name: "ALDI Süd",
    type: "discounter",
    confidence: "hoch",
    note: "Von ALDI Süd selbst beschriebene Folge: Obst und Gemüse am Eingang, gegenüber Fleisch und Fisch, Stirnseitenkühlung, Familienwelt kassennah. Position der Backwelt bleibt offen.",
    categoryOrder: ["obst_gemuese", "fleisch_fisch", "backwaren", "trockensortiment", "molkerei", "wurst_kaese", "tiefkuehl", "suesswaren", "getraenke", "baby", "drogerie", "haushalt", "aktion", "kasse"],
  },
  {
    key: "lidl",
    name: "Lidl",
    type: "discounter",
    confidence: "mittel",
    note: "Früher Frischestart und sichtbarer Backshop sind stabil, die Folge danach ist je Konzeptgeneration unterschiedlich (Kühlpassage, Tiefkühlpassage, zweiseitiger Drogeriebereich).",
    categoryOrder: ["obst_gemuese", "backwaren", "fleisch_fisch", "molkerei", "wurst_kaese", "trockensortiment", "aktion", "suesswaren", "tiefkuehl", "getraenke", "drogerie", "haushalt", "kasse"],
  },
  {
    key: "penny",
    name: "PENNY",
    type: "discounter",
    confidence: "niedrig",
    note: "Markthallen-Konzept mit Regalbuchten statt Querregalierung, keine belastbare bundesweite Startabteilung. Reihenfolge hier als Arbeitshypothese, die App sollte hier besonders schnell nachlernen.",
    categoryOrder: ["obst_gemuese", "backwaren", "convenience", "molkerei", "fleisch_fisch", "trockensortiment", "suesswaren", "tiefkuehl", "getraenke", "haushalt", "drogerie", "kasse"],
  },
  {
    key: "kaufland",
    name: "Kaufland",
    type: "sb_warenhaus",
    confidence: "hoch",
    note: "Klar beschriebene Sequenz: Leergut und Kundeninformation am Eingang, dann Obst und Gemüse, To-go und Bäckerei, Trockensortiment, gekoppelte Bedien- und SB-Frische, Kühlung, Tiefkühl, Getränke kurz vor der Kasse. Nonfood-Position bleibt offen.",
    categoryOrder: ["obst_gemuese", "convenience", "backwaren", "trockensortiment", "theke", "fleisch_fisch", "wurst_kaese", "molkerei", "tiefkuehl", "suesswaren", "drogerie", "haushalt", "baby", "tier", "aktion", "getraenke", "kasse"],
    expressRoute: ["obst_gemuese", "convenience", "backwaren", "kasse"],
  },
  {
    key: "edeka",
    name: "Edeka",
    type: "vollsortimenter",
    confidence: "niedrig",
    note: "Verbund aus selbstständigen Kaufleuten, kein einheitlicher Filialplan. Robust sind nur frühe Obst- und Gemüsezone, Bäckerei nahe Eingang, Kühlung am Rand, Getränke vor der Kasse. Formate reichen vom Nahversorger bis zum E center.",
    categoryOrder: ["backwaren", "obst_gemuese", "trockensortiment", "suesswaren", "theke", "fleisch_fisch", "wurst_kaese", "molkerei", "tiefkuehl", "drogerie", "haushalt", "baby", "tier", "getraenke", "kasse"],
  },
  {
    key: "rewe",
    name: "Rewe",
    type: "vollsortimenter",
    confidence: "niedrig",
    note: "In der Recherche nicht eigenständig untersucht. Reihenfolge analog zu Edeka als Startannahme, bis die App nachgelernt hat.",
    categoryOrder: ["obst_gemuese", "backwaren", "theke", "fleisch_fisch", "wurst_kaese", "molkerei", "trockensortiment", "suesswaren", "tiefkuehl", "drogerie", "haushalt", "baby", "tier", "getraenke", "kasse"],
  },
  {
    key: "netto",
    name: "Netto",
    type: "discounter",
    confidence: "niedrig",
    note: "Startannahme analog zu den übrigen Discountern.",
    categoryOrder: ["obst_gemuese", "backwaren", "molkerei", "wurst_kaese", "fleisch_fisch", "trockensortiment", "suesswaren", "tiefkuehl", "getraenke", "haushalt", "drogerie", "kasse"],
  },
  {
    key: "dm",
    name: "dm",
    type: "drogerie",
    confidence: "niedrig",
    note: "Navigation über Sortimentsviertel und Landmarken (Gloriole für Make-up, Ginkgoblätter für Gesundheit, Baum für Kindertextilien), keine feste bundesweite Reihenfolge. Abholstation oft im Eingangsbereich.",
    categoryOrder: ["beauty", "haar", "drogerie", "haushalt", "baby", "gesundheit", "ernaehrung", "tier", "kasse"],
    landmarks: ["Abholstation", "Beauty-Insel", "Ginkgoblätter", "Kinderwelt", "Fototheke"],
  },
  {
    key: "rossmann",
    name: "Rossmann",
    type: "drogerie",
    confidence: "niedrig",
    note: "Startannahme analog dm, ohne eigene Untersuchung.",
    categoryOrder: ["beauty", "haar", "drogerie", "haushalt", "baby", "gesundheit", "ernaehrung", "tier", "kasse"],
  },
  {
    key: "baumarkt",
    name: "Baumarkt (Obi, Bauhaus, Hornbach)",
    type: "baumarkt",
    confidence: "niedrig",
    note: "Sammelprofil ohne eigene Untersuchung. Reihenfolge stark abhängig von Fläche und Gartencenter-Anbindung.",
    categoryOrder: ["garten", "bauen_holz", "werkzeug", "eisenwaren", "elektro", "sanitaer", "farben", "deko", "kasse"],
  },
  {
    key: "asiamarkt",
    name: "Asiamarkt",
    type: "spezialmarkt",
    confidence: "niedrig",
    note: "Sammelprofil, meist kleine Flächen mit sehr individueller Anordnung.",
    categoryOrder: ["asia_frische", "asia_tofu", "asia_nudeln_reis", "asia_saucen", "trockensortiment", "tiefkuehl", "suesswaren", "getraenke", "kasse"],
  },
] as const satisfies readonly ChainProfile[];

export type ChainKey = (typeof CHAIN_PROFILES)[number]["key"];

export function chainProfile(key: ChainKey): ChainProfile {
  const found = CHAIN_PROFILES.find((profile) => profile.key === key);
  if (!found) throw new Error(`Unbekannte Kette: ${key}`);
  return found;
}
